/*
  Wishlist King mounts the collection/search card "favorites" heart at the
  <div class="shopify-section"> level (a sibling of the product grid) and then
  positions each one with a JS-set transform computed from the card's quick-add
  button — which lands the heart in the MIDDLE of the card on this theme. It's
  also non-deterministic: sometimes it injects the heart directly inside
  .card__media instead. Either way we want the heart pinned to the top-right of
  the card image.

  This moves every <wishlist-button-collection> into its own card's .card__media
  (a position:relative box), where the CSS in llm-product-card.css
  (`.card__media > wishlist-button-collection .wk-floating { top:8px; right:8px;
  transform:none !important }`) pins it to the top-right. We map a section-level
  heart back to its card via the `floating` attribute's [wk-id] reference, which
  points at an element inside the card.

  Runs on load + a MutationObserver so it also catches the app's async injection,
  infinite scroll, and Meilisearch filter re-renders. The observer only watches
  childList (new nodes), so the app's own inline transform updates (style/attr
  changes) don't retrigger it, and moving an already-placed heart is a no-op — so
  there's no loop.
*/
(function () {
  function findCard(heart) {
    var card = heart.closest('product-card');
    if (card) return card;
    // Prefer the product handle — it's set on the element early and is the most
    // reliable link back to the card.
    var handle = heart.getAttribute('data-product-handle');
    if (handle) {
      var link = document.querySelector('product-card a[href*="/products/' + handle + '"]');
      if (link) return link.closest('product-card');
    }
    // Fall back to the floating [wk-id] reference the app points the heart at.
    var floatAttr = heart.getAttribute('floating') || '';
    var match = floatAttr.match(/wk-id[^"]*"([^"\\]+)/);
    if (match) {
      try {
        var ref = document.querySelector('[wk-id="' + match[1] + '"]');
        if (ref) return ref.closest('product-card');
      } catch (e) {}
    }
    return null;
  }

  function fixHearts() {
    // Exclude our own manually-mounted hearts: the product-page photo heart
    // (.llm-photo-heart) and the per-card heart (.llm-card-heart, placed by
    // product-card.liquid) are already positioned/styled and hydrated in place.
    // This leaves only the app's auto-injected collection copies — which the CSS
    // in llm-product-card.css hides as duplicates anyway; moving them is a
    // harmless no-op kept as a belt-and-suspenders for any card that somehow
    // lacks the manual mount.
    var hearts = document.querySelectorAll(
      'wishlist-button-collection:not(.llm-photo-heart):not(.llm-card-heart)'
    );
    for (var i = 0; i < hearts.length; i++) {
      var heart = hearts[i];
      var card = findCard(heart);
      if (!card) continue;
      var media = card.querySelector('.card__media');
      if (!media) continue;
      if (heart.parentElement !== media) media.appendChild(heart);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    // setTimeout (not requestAnimationFrame): rAF is paused in background/
    // unfocused tabs, which would leave the hearts unmoved until the tab is
    // focused. setTimeout still fires.
    setTimeout(function () {
      scheduled = false;
      fixHearts();
    }, 50);
  }

  function start() {
    // NOTE: no early-out on `product-card` existing — the collection/search grid
    // is client-rendered by the Meilisearch system, so the cards (and the app's
    // hearts) appear AFTER this deferred script runs. The observer below is what
    // catches them.
    schedule();
    // Watch childList (new hearts / infinite scroll / filter re-renders) AND the
    // key wishlist attributes: the app injects an empty <wishlist-button-collection>
    // first and only sets data-product-handle / floating / wk-loaded a tick later,
    // so we must re-run when those land, not just on insertion.
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['wk-loaded', 'floating', 'data-product-handle']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
